const validateSet = (set) => {
  for (let i = 0; i < set.length; ++i) {
    if (set[i] !== true) {
      return set[i];
    }
  }
  return true;
};

export const validateActionPath = (path = '') => {
  if (path.length < 1) {
    return 'Missing URI.';
  }
  if (path[0] === '/') {
    return 'Path should not start with a slash.';
  }
  if (path.includes(' ')) {
    return 'Path should not contain spaces.';
  }
  return true;
};

export const validateActionMethod = (method) => {
  if (!method) {
    return 'Missing method.';
  }
  return true;
};

export const validateActionAttributesGroup = (action) => {
  const attributes = action?.attributes || [];
  if (attributes.length < 1) {
    return 'Missing attributes.';
  }
  const missingDataTypes = attributes.filter((a) => !a?.dataType).map((n) => n?.key);
  if (missingDataTypes.length > 0) {
    return `Missing data type for attribute(s): ${missingDataTypes.join(', ')}`;
  }

  const missingMockTypes = attributes.filter((a) => !a?.mockType).map((n) => n?.key);
  if (missingMockTypes.length > 0) {
    return `Missing mock type for attribute(s): ${missingMockTypes.join(', ')}`;
  }

  return true;
};

export const validateActionOutputGroup = (output) => {
  const responses = output?.response;
  if (!responses || responses?.length < 1) {
    return 'The action must be run.';
  }
  if (!Array.isArray(responses)) {
    return 'Responses must be an array.';
  }
  const failures = responses?.filter((r) => r?.data?.success !== true) || [];
  if (failures?.length > 0) {
    return `${failures.length} response(s) failed.`;
  }
  return true;
};

export const validateActionOutboundOutputGroup = (output) => {
  const responses = output?.response;
  if (!responses || responses?.length < 1) {
    return 'The action must be run.';
  }
  if (!Array.isArray(responses)) {
    return 'Responses must be an array.';
  }
  const failures = responses?.filter((r) => r?.success !== true) || [];
  if (failures?.length > 0) {
    return `${failures.length} response(s) failed.`;
  }
  return true;
};

export const validateActionPresentationGroup = (action) => {
  const presentation = action?.presentation;
  if (!presentation) {
    return 'Missing presentation settings.';
  }
  if (!presentation?.type) {
    return 'Missing presentation type.';
  }

  if (presentation?.type === 'card') {
    const fields = ['name', 'description', 'image', 'id'];
    const missing = fields.filter((f) => !presentation?.fields?.[f]?.value);
    if (missing?.length > 0) {
      return `Missing presentation field(s): ${missing.join(', ')}`;
    }
  }

  return true;
};

export const validateActionSignatureGroup = (action) => {
  return validateSet([
    validateActionPath(action?.api?.path), //
    validateActionMethod(action?.api?.method)
  ]);
};
